








































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Livraison, DestType} from '@/models';

import storeLivraison from '@/stores/modules/livraison';
import storeTransporteur from "@/stores/modules/transporteur";

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudLongueursAchatSearch from "@/components/Crud/LongueursAchat/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import InputEnumSelect from "@/components/Input/EnumSelect.vue";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudClientSearch,
		CrudLongueursAchatSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursAchat,
		InputDatePicker,
		InputEnumSelect,
	}
})
export default class CrudLivraisonEdit extends AbstractEditVue<Livraison> {

	// DF: utiliser pour la création d'un livraison uniquement
	// en modification on passe par la light
	private step: number = 1;
	private DestType = DestType;
	private savedisabled: Boolean = true;
	private storeTransporteur = storeTransporteur
	private volumeUnite: string = 'Volume';

	public constructor() {
		super(
			storeLivraison,
			'Livraison modifié',
			'Livraison créé',
		);
	}

	private checkInputs(): void {
		if (this.item)
		{
			if (this.item.transporteur || this.value.transporteur)
			{
				this.savedisabled = false;
			}
			else
			{
				this.savedisabled = true;
			}
		}
	}

//	@Emit()
//	private onNext() {
//		if ((!this.item.address) || (this.item.address === null) )
//		{
//			this.item.address = this.item.name;
//		}
//		this.step = 2;
//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeTransporteur.dispatch('getC', {filters: false});
		await super.mounted();
		this.checkInputs();
		this.volumeUnite = 'Volume (' + this.item.essenceAchat.unite + ')';
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route livraison edit = ' + this.$route.name);
		if (this.$route.name === 'livraison-edit') {
			this.$route.meta.title = 'Modification  d\'une essence achetée';
		}
	}

}
